import React, { useContext, useEffect, useState } from "react";
import {
   Grid,
   NumberInput,
   Select,
   Button,
   Switch,
   TextInput,
   Loader,
   MultiSelect,
} from "@mantine/core";
import { generateRandomCode } from "../../../utils/generateRandomCode";
import AppContext from "../../../contexts/AppContext";
import "./DiscountsForm.css";


const RESTRICTION_TYPE_ENUM = [{value: '', label: "Genérico"},{ value: 'ACADEMIC_UNIT', label: "Por unidad academica" }, { value: 'SPECIALTY', label: "Por especialidad" }, { value: 'ACADEMIC_UNIT_TYPE', label: "Por tipo de unidad académica" }]


function DiscountsForm(props) {
   const { form, loading, initialValuesEdit, disabledInputs } = props;
   const { academicUnits, avals, specialties, academicUnitTypes } = useContext(AppContext);

   const [usesQuantity, setUsesQuantity] = useState(
      initialValuesEdit?.max_uses || ""
   );
   const [multipleValues, setMultipleValues] = useState(
      initialValuesEdit?.max_uses > 1
   );
   const [isActive, setIsActive] = useState(initialValuesEdit?.active);

   const avalOptions = [{ value: "FORVET", label: "FORVET" }, ...avals];

   const handleUsesQuantityChange = (value) => {
      if (value === "multiple") {
         setMultipleValues(true);
         setUsesQuantity(""); // Clear the quantity input when "multiple" is selected
         form.setFieldValue("use", { max_uses: "" });
      } else if (value === "single") {
         setMultipleValues(false);
         setUsesQuantity(1);
         form.setFieldValue("use", { max_uses: 1 });
      } else {
         setMultipleValues(false);
         setUsesQuantity("");
         form.setFieldValue("use", { max_uses: "" });
      }
   };

   const handleQuantityInputChange = (event) => {
      const value = event.currentTarget.value;
      setUsesQuantity(value);
      form.setFieldValue("use", { ...form.values.use, max_uses: value });
   };

   const handleActiveDiscount = () => {
      const newValue = !isActive;
      setIsActive(newValue);
      form.setFieldValue("active", newValue);
   };

   const [otherDiscount, setOtherDiscount] = useState(initialValuesEdit?.other_discount)

   return (
      <div style={{ width: "100%" }}>
         <div className="mainSwitch-styling">
            <Switch
               classNames={{ root: "switch-root-styling" }}
               checked={otherDiscount}
               label="Otras opciones de descuento"
               onChange={() => setOtherDiscount(prevState => !prevState)}
            />
         </div>
         <Grid>
            {otherDiscount &&
               <Grid.Col span={12}>
                  <Select
                     {...form.getInputProps("other_discount")}
                     placeholder="Selecciona una opción:"
                     withAsterisk
                     data={[
                        { value: "dolar-forvet", label: "Dólar FORVET" },
                     ]}
                     onChange={(value) => {
                        form.setFieldValue("other_discount", value);
                     }}
                  />
               </Grid.Col>
            }
            <Grid.Col span={12}>
               <Select
                  {...form.getInputProps("institutional_name")}
                  withAsterisk
                  label="Institución"
                  searchable={true}
                  data={avalOptions}
                  onChange={(value) => {
                     form.setFieldValue("institutional_name", value);
                  }}
               />
            </Grid.Col>
            <Grid.Col span={12}>
                     <Select
                        label="Tipo de uso"
                        data={[
                           { value: "single", label: "Uso único" },
                           { value: "multiple", label: "Uso múltiple" },
                        ]}
                        onChange={(value) => handleUsesQuantityChange(value)}
                        disabled={disabledInputs?.usesQuantityInput}
                        value={
                           multipleValues ? "multiple" : usesQuantity === 1 ? "single" : ""
                        }
                     />
                  </Grid.Col>
                  {multipleValues && (
                     <Grid.Col span={12}>
                        <TextInput
                           label="Cantidad de usos"
                           type="number"
                           min={1}
                           value={usesQuantity}
                           onChange={handleQuantityInputChange}
                        />
                     </Grid.Col>
                  )}
                  <Grid.Col span={12}>
                     <Select
                        {...form.getInputProps("restriction_type")}
                        withAsterisk
                        label="Tipo de aplicación"
                        searchable={true}
                        data={RESTRICTION_TYPE_ENUM}
                        required
                        defaultValue={''}
                        allowDeselect={false}
                        disabled={!form.values.institutional_name}
                        placeholder={
                           !form.values.institutional_name
                              ? "Para usar este campo debe seleccionar una institución primero"
                              : "Seleccione una"
                        }
                        onChange={(value) => {
                           form.setFieldValue("restriction_type", value);
                           form.setFieldValue("restriction_value", []);
                        }}
                     />
                  </Grid.Col>
                  {form.values.restriction_type === 'ACADEMIC_UNIT' && <Grid.Col span={12}>
                     <MultiSelect
                        {...form.getInputProps("restriction_value")}
                        withAsterisk
                        label="Unidad académica"
                        searchable={true}
                        maxValues={1}
                        data={academicUnits}
                        disabled={!form.values.institutional_name}
                        placeholder={
                           !form.values.institutional_name
                              ? "Para usar este campo debe seleccionar una institución primero"
                              : "Seleccione una unidad académica"
                        }
                        onChange={(value) => {
                           const codes = value.map((v) => {
                              const item = academicUnits.find((_item) => _item.value === v);
                              if (!item) return null;

                              const splitName = item.label.split(" ");
                              const academicUnitName = splitName.map((_word) => _word.charAt(0)).join("").toUpperCase();

                              return `${academicUnitName}-${generateRandomCode(3)}`;
                           }).filter(Boolean);

                           form.setFieldValue(
                              "code",
                              `${form.values.institutional_name}-${codes.join("")}`
                           );
                           form.setFieldValue("restriction_value", value);
                        }}
                     />
                  </Grid.Col>
                  }
                  {form.values.restriction_type === 'SPECIALTY' && <Grid.Col span={12}>
                     <MultiSelect
                        {...form.getInputProps("restriction_value")}
                        withAsterisk
                        label="Especialidad"
                        searchable={true}
                        data={specialties}
                        disabled={!form.values.institutional_name}
                        placeholder={
                           !form.values.institutional_name
                              ? "Para usar este campo debe seleccionar una institución primero"
                              : "Seleccione una especialidad"
                        }
                        onChange={(value) => {
                           const codes = value.map((v) => {
                              const item = specialties.find((_item) => _item.value === v);
                              if (!item) return null;

                              const splitName = item.label.split(" ");
                              const specialtyName = splitName.map((_word) => _word.charAt(0)).join("").toUpperCase();

                              return `${specialtyName}-${generateRandomCode(3)}`;
                           }).filter(Boolean);

                           form.setFieldValue(
                              "code",
                              `${form.values.institutional_name}-${codes.join("")}`
                           );
                           form.setFieldValue("restriction_value", value);
                        }}
                     />
                  </Grid.Col>
                  }
                  {form.values.restriction_type === 'ACADEMIC_UNIT_TYPE' && <Grid.Col span={12}>
                     <MultiSelect
                        {...form.getInputProps("restriction_value")}
                        withAsterisk
                        label="Tipo de capacitación"
                        searchable={true}
                        data={academicUnitTypes}
                        disabled={!form.values.institutional_name}
                        placeholder={
                           !form.values.institutional_name
                              ? "Para usar este campo debe seleccionar una institución primero"
                              : "Seleccione una"
                        }
                        onChange={(value) => {
                           const codes = value.map((v) => {
                              const item = academicUnitTypes.find((_item) => _item.value === v);
                              if (!item) return null;

                              const splitName = item.label.split(" ");
                              const current_name = splitName.map((_word) => _word.charAt(0)).join("").toUpperCase();

                              return `${current_name}-${generateRandomCode(2)}`;
                           }).filter(Boolean);

                           form.setFieldValue(
                              "code",
                              `${form.values.institutional_name}-${codes.join("")}`
                           );
                           form.setFieldValue("restriction_value", value);
                        }}
                     />
                  </Grid.Col>
                  }

            <Grid.Col span={6}>
               <NumberInput
                  {...form.getInputProps("percentage")}
                  min={1}
                  max={100}
                  withAsterisk
                  label="Porcentaje de descuento"
               />
            </Grid.Col>
            <Grid.Col span={6}>
               {(initialValuesEdit && !disabledInputs?.activeSwitch) && (
                  <div className="discountsForm__SwitchDiv">
                     <Switch
                        checked={isActive}
                        label="Estado del descuento"
                        onChange={handleActiveDiscount}
                     />
                  </div>
               )}
            </Grid.Col>
            <Grid.Col span={12}>
               <TextInput
                  {...form.getInputProps("code")}
                  withAsterisk
                  label="Nombre del código de descuento"
                  placeholder="Ingrese el nombre del código"
               />
            </Grid.Col>
            {!disabledInputs?.submitButton &&
               <Grid.Col span={12}>
                  <Button
                     type="submit"
                     className="createDiscount__button"
                     loading={loading}
                  >
                     {loading
                        ? <Loader color="#fff" />
                        : (initialValuesEdit?.id || initialValuesEdit?._id)
                           ? "Guardar descuento"
                           : "Crear descuento"

                     }
                  </Button>
               </Grid.Col>
            }
         </Grid>
      </div>
   );
}

export default DiscountsForm;
